import { View, Image, Text } from '@react-pdf/renderer';
import { headerStyle } from './style';

interface IHeader {
    period?: string;
    userInfo?: string;
}

export const Header = ({ period, userInfo }: IHeader) => {
    const headerTitle = userInfo ? `${userInfo}'s Leave Requests List` : 'Leave Requests List';
    return (
        <View style={headerStyle.header}>
            <View style={headerStyle.info}>
                <Text style={headerStyle.title}>{headerTitle}</Text>
                {period && <Text style={headerStyle.period}>{period}</Text>}
            </View>
            <Image style={headerStyle.image} src="/img/fornulio-logo.jpg" />
        </View>
    );
};
